import type { CrmTaskDTO } from '../../../server/dto/crm-task-dto.ts';
import { api } from '../../../utils/api.ts';

type UseUpdateTaskOptions = {
    onSuccess?: (data: CrmTaskDTO) => void;
    onError?: (message?: string) => void;
};

export function useUpdateTask(options: UseUpdateTaskOptions = {}) {
    const apiUtils = api.useUtils();

    const updateTaskMutation = api.platoUser.command.tasks.postTasksActions.update.useMutation({
        onSuccess(data, { taskId }) {
            // Invalidate related queries to refetch fresh data
            void Promise.all([
                apiUtils.platoUser.query.tasks.getManyTasks.find.invalidate({ taskId }),
                apiUtils.platoUser.query.tasks.getManyTasks.getListWithFilters.invalidate(),
                apiUtils.platoUser.query.tasks.getManyTasks.getUpcomingCustomerTasks.invalidate(),
                apiUtils.platoUser.query.customerActivity.getFeedList.withFilters.invalidate(),
            ]);

            options.onSuccess?.(data);
        },
    });

    return updateTaskMutation;
}
